module.exports = __webpack_public_path__ + "img/1_B.2ee7c7e1.webp";